import { YoutubeOfflineChip } from './YoutubeOfflineChip';

/** Offline header shown above the recent YouTube Native broadcasts list. */
export function YoutubeOfflineHeader() {
  return <YoutubeOfflineChip />;
}
